module.exports = __webpack_public_path__ + "img/img-06.6d664fdd.png";